<template>
    <div class="time-slots-component-container">
        <div class="time-slots-settings-container">
            <div class="select-time-text-container">
                <p>{{ $t('select_time') }}</p>
            </div>
            <div class="time-slots-settings-content-container">
                <div class="time-slots-settings-btn-container" @click="toggleDisplaySettingsFiltersBtnsHandle">
                    <div class="time-slots-settings-img-container">
                        <img src="../../assets/icons/time_slots_settings.png" alt="Settings icon">
                    </div>
                </div>
                <div v-if="showSettingsFiltersBtns" class="settings-filters-options-container">
                    <ul class="filters-options-container-list">
                        <li class="filter-container" v-for="(filterOptions, index) in filtersOptions" :key="index" 
                            @click="showFilterPopup(index)" :class="{'filter-selected' : filterOptions.active}">
                            <div class="filter-img-container" :class="`${filterOptions.name}-filter-img-container`">
                                <img :src="require(`../../assets/icons/${filterOptions.name}.png`)" alt="Filter icon">
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="available-time-slots-container scroll-bar">
            <ul v-if="displayedTimeSlots.length > 0" class="day-time-slots-list">
                <li class="time-slot-item" v-for="dayPart in dayParts" :key="dayPart">
                    <div class="time-slots-group-container">
                        <ul class="time-slot-group-list">
                            <!-- <li class="time-slot" :class="[{'selected-time-slot': selectedDayPart == index1 && selectedTimeSlotIndex == index2}]" v-for="(timeSlot, index2) in timeSlotsGroupObj" :key="index2" @click="selectTimeSlot(index1, index2)">
                                <p :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ extractTimeFromDate(timeSlot.Start_DateTime) }}</p>
                            </li> -->
                            <li class="time-slot" :class="[{'selected-time-slot': selectedDayPart == dayPart && selectedTimeSlotIndex == index}]" v-for="(slot, index) in displayedTimeSlots.filter(s => s.Day_Part === dayPart)" :key="slot.Start_DateTime" @click="selectTimeSlot(dayPart, index, slot)">
                                <p :class="$store.requestSource.includes('webView') ? 'center-text-with-vag-font' : ''">{{ extractTimeFromDate(slot.Start_DateTime) }}</p>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>

            <div v-else class="no-available-time-slots-text-container">
                <p>{{ $t('no_times_available') }}</p>
            </div>
        </div>

        <SettingsFiltersPopup v-if="clickedFilterIndex > -1" :clickedFilterIndex="clickedFilterIndex"
            :clickedFilterOptions="clickedFilterOptions" :closeSettingsFiltersPopup="closeSettingsFiltersPopup"
            :applyFilter="applyFilter"
        /> <!-- :trainerGenderFilterOptions="trainerGenderFilterOptions" :subscriptionTypeFilterOptions="subscriptionTypeFilterOptions" -->
    </div>
</template>

<script>
import SettingsFiltersPopup from './SettingsFiltersPopup.vue';
export default {
    name: "TimeSlotsComponent",
    components: {
        SettingsFiltersPopup,
    },
    props: {
        clientEventsObj: Object,
        selectedEvent:Object,
        selectedDayTimeSlots: Array,
        extractTimeFromDate: Function,
        // toggleNoAvailableTimeSlotsFounded: Function,
        toggoleDisplayingSaveBtnHandle: Function,
        updateSelectedDayTimeSlots: Function,
        filtersOptions: Array,
        updateFilterOptions: Function,
        updateRescheduleEventDataObject: Function,
        // resetSelectedTimeSlot: Function,
    },
    data() {
        return {
            showSettingsFiltersBtns: true,
            timeFilterSelected: false,
            trainerGenderFilterSelected: false,
            subscriptionTypeFilterSelected: false,
            displayedTimeSlots: this.selectedDayTimeSlots,
            // filtersOptions: [
            //     {
            //         name: "time",
            //         active: false,
            //         options: {
            //             morning: false,
            //             afternoon: false,
            //             evening: false,
            //         }
            //     },
            //     // {
            //     //     name: "trainer_gender",
            //     //     active: false,
            //     //     options: {
            //     //         "Male trainer": false,
            //     //         "Female trainer": false,
            //     //     }
            //     // },
            //     // {
            //     //     name: "subscroption_type",
            //     //     active: false,
            //     //     options: {
            //     //         flex: false,
            //     //         duo: false,
            //     //         solo: false,
            //     //     }
            //     // },
            // ],
            clickedFilterIndex: -1,
            clickedFilterOptions: {},
            selectedDayPart: null,
            selectedTimeSlotIndex: null,
            dayParts: ['morning', 'afternoon', 'evening'],
        }
    },
    methods: {
        toggleDisplaySettingsFiltersBtnsHandle: function () {
            this.showSettingsFiltersBtns = !this.showSettingsFiltersBtns;
        },
        showFilterPopup: function (filterIndex) {
            this.clickedFilterIndex = filterIndex;
            this.clickedFilterOptions = this.filtersOptions[filterIndex];
        },
        closeSettingsFiltersPopup: function () {
            this.clickedFilterIndex = -1;
            this.clickedFilterOptions = {};
        },
        updateRescheduleEventDataObjectHandle: function (newObjData) {
            this.updateRescheduleEventDataObject(newObjData);
            // console.log(this.rescheduleEventData);
        },
        // applyFilter: function (filterObj) {
        //     // Check if one of the options has selected and return true, Otherwise, return false.
        //     let activeFilter = Object.keys(filterObj.options).some(key => filterObj.options[key]);

        //     filterObj.active = activeFilter;
        //     this.updateFilterOptions(filterObj, this.clickedFilterIndex);

        //     // console.log(this.filtersOptions);

        //     let filteredTimeSlots = {};

        //     if (activeFilter) {
        //         let noAvailableTimeSlots = true;

        //         Object.keys(filterObj.options).forEach(key1 => {
        //             Object.keys(this.selectedDayTimeSlots).forEach(key2 => {
        //                 if (filterObj.options[key1] && key1 === key2) {
        //                     // console.log(key2);
        //                     // console.log(this.selectedDayTimeSlots[key2]);
        //                     filteredTimeSlots[key1] = this.selectedDayTimeSlots[key2];
        //                     // console.log(this.selectedDayTimeSlots[key2].length);
        //                     if (this.selectedDayTimeSlots[key2].length > 0) {
        //                         noAvailableTimeSlots = false;
        //                     }
        //                 }
        //             });
        //         });

        //         if (noAvailableTimeSlots) {
        //             this.displayedTimeSlots = false;
        //         }
        //         else {
        //             this.displayedTimeSlots = JSON.parse(JSON.stringify(filteredTimeSlots));
        //         }
        //     }
        //     else {
        //         this.displayedTimeSlots = JSON.parse(JSON.stringify(this.selectedDayTimeSlots));
        //     }

        //     // console.log(filterObj.options);
        //     // console.log(this.selectedDayTimeSlots);
        //     // console.log(filteredTimeSlots);
        //     // console.log(this.selectedDayPart);
        //     // console.log(this.selectedDayTimeSlots[this.selectedDayPart]);

        //     // If the client select a time slot and then he select a filter group(s). Check if the selected group(s) still has that selected time slot.
        //     // If not, clear the selected time slot indexes and hide the save button.
        //     if (activeFilter && !filteredTimeSlots[this.selectedDayPart]) {
        //         this.selectedDayPart = null;
        //         this.selectedTimeSlotIndex = null;
        //         this.updateRescheduleEventDataObject(null);
        //         this.toggoleDisplayingSaveBtnHandle(false);
        //     }

        //     this.closeSettingsFiltersPopup();
        // },
        applyFilter: function (filterObj) {
            // Check if one of the options has selected and return true, Otherwise, return false.
            let activeFilter = Object.keys(filterObj.options).some(key => filterObj.options[key]);

            filterObj.active = activeFilter;
            this.updateFilterOptions(filterObj, this.clickedFilterIndex);

            // console.log(this.filtersOptions);

            let filteredTimeSlots = [];

            if (activeFilter) {
                let noAvailableTimeSlots = true;

                Object.keys(filterObj.options).forEach(key1 => {
                    // Object.keys(this.selectedDayTimeSlots).forEach(key2 => {
                    //     if (filterObj.options[key1] && key1 === key2) {
                    //         // console.log(key2);
                    //         // console.log(this.selectedDayTimeSlots[key2]);
                    //         filteredTimeSlots[key1] = this.selectedDayTimeSlots[key2];
                    //         // console.log(this.selectedDayTimeSlots[key2].length);
                    //         if (this.selectedDayTimeSlots[key2].length > 0) {
                    //             noAvailableTimeSlots = false;
                    //         }
                    //     }
                    // });

                    this.selectedDayTimeSlots.forEach((dayTimeSlot) => {
                        if (filterObj.options[key1] && key1 === dayTimeSlot.Day_Part) {
                            // console.log(dayIndex);
                            // console.log(dayTimeSlots);
                            filteredTimeSlots.push(dayTimeSlot);
                            // console.log(dayTimeSlots.length);
                        }
                    });
                });

                if (filteredTimeSlots.length > 0) {
                    noAvailableTimeSlots = false;
                }

                if (noAvailableTimeSlots) {
                    this.displayedTimeSlots = false;
                }
                else {
                    this.displayedTimeSlots = filteredTimeSlots;
                }
            }
            else {
                this.displayedTimeSlots = this.selectedDayTimeSlots;
            }

            // console.log(this.displayedTimeSlots);
            // console.log(this.selectedDayTimeSlots);

            // console.log(filterObj.options);
            // console.log(this.selectedDayTimeSlots);
            // console.log(filteredTimeSlots);
            // console.log(this.selectedDayPart);
            // console.log(this.selectedDayTimeSlots[this.selectedDayPart]);

            // If the client select a time slot and then he select a filter group(s). Check if the selected group(s) still has that selected time slot.
            // If not, clear the selected time slot indexes and hide the save button.
            if (activeFilter && filteredTimeSlots.length === 0) {
                this.selectedDayPart = null;
                this.selectedTimeSlotIndex = null;
                this.updateRescheduleEventDataObjectHandle(null);
                this.toggoleDisplayingSaveBtnHandle(false);
            }

            this.closeSettingsFiltersPopup();
        },
        selectTimeSlot: function (dayPart, timeSlotIndex, timeSlotObj) {
            this.selectedDayPart = dayPart;
            this.selectedTimeSlotIndex = timeSlotIndex;
            // console.log("newStartDateTime: " + this.selectedDayTimeSlots[this.selectedDayPart][this.selectedTimeSlotIndex].Start_DateTime);
            // console.log("newEndDateTime: " + this.selectedDayTimeSlots[this.selectedDayPart][this.selectedTimeSlotIndex].End_DateTime);
            // console.log("ownerEventId: " + this.selectedEvent.id);
            // console.log(this.clientEventsObj.partnerData.events);

            let partnerEventId = '';
            if (this.clientEventsObj.partnerData) {
                this.clientEventsObj.partnerData.events.forEach(eventObj => {
                    if (this.selectedEvent.Start_DateTime === eventObj.Start_DateTime && this.selectedEvent.End_DateTime == eventObj.End_DateTime) {
                        partnerEventId = eventObj.id;
                    }
                })
            }

            const rescheuleEventDataObj = {
                ownerEventId: this.selectedEvent.id,
                clientName: this.clientEventsObj.clientName,
                newStartDateTime: timeSlotObj.Start_DateTime,
                newEndDateTime: timeSlotObj.End_DateTime,
                partnerEventId: partnerEventId,
                prevSessionDate: this.clientEventsObj.startDateTimePrevNextSessions.startDateTimePreviousSession,
                nextSessionDate: this.clientEventsObj.startDateTimePrevNextSessions.startDateTimeOf9thNextSession,
                studioTimeZone: this.$store.user.studiosInfo[0].studioTimeZone,
                reactiveCancelledPartnerEvent: false,
            }

            // console.log(this.clientEventsObj);

            // console.log(this.clientEventsObj.startDateTimePrevNextSessions);

            this.updateRescheduleEventDataObjectHandle(rescheuleEventDataObj);

            // console.log(this.selectedDayTimeSlots[this.selectedDayPart][this.selectedTimeSlotIndex]);
            this.toggoleDisplayingSaveBtnHandle(true);
        },
    },
    watch: {
        // Watch for changes in the `selectedDayTimeSlots` prop and update `displayedTimeSlots`
        selectedDayTimeSlots: {
            handler(newVal) {
                this.displayedTimeSlots = newVal;

                // console.log(this.filtersOptions);
                // console.log(this.selectedDayTimeSlots);

                if (newVal) {
                    // Check if a time slot has selected and the day has changed, reset the selected time slot and hide the save button.
                    this.selectedDayPart = null;
                    this.selectedTimeSlotIndex = null;
                    this.toggoleDisplayingSaveBtnHandle(false);

                    // Check if there is an active filter and the day has changed, execute the active filter on the new selected day.
                    Object.keys(this.filtersOptions).forEach(key => {
                        // console.log(this.filtersOptions[key].options);
                        // let activeFilter = false;

                        if (this.filtersOptions[key]) {
                            // Check if one of the options has selected and return true, Otherwise, return false.
                            const activeFilter = Object.keys(this.filtersOptions[key].options).some(key1 => this.filtersOptions[key].options[key1]);

                            if (activeFilter) {
                                // this.applyFilter(this.filtersOptions[key]);
                                let filteredTimeSlots = [];

                                let noAvailableTimeSlots = true;

                                Object.keys(this.filtersOptions[key].options).forEach(key1 => {
                                    // console.log("this.filtersOptions[key].options[key1]: " + this.filtersOptions[key].options[key1]);
                                    // console.log("key1: " + key1);
                                    this.selectedDayTimeSlots.forEach(timeSlot => {
                                        // console.log("timeSlot.Day_Part: " + timeSlot.Day_Part);
                                        if (this.filtersOptions[key].options[key1] && key1 === timeSlot.Day_Part) {
                                            // console.log("timeSlot.Day_Part: " + timeSlot.Day_Part);
                                            // // console.log(this.selectedDayTimeSlots[key2]);
                                            // filteredTimeSlots[key1] = this.selectedDayTimeSlots[key2];
                                            filteredTimeSlots.push(timeSlot);
                                            // // console.log(this.selectedDayTimeSlots[key2].length);
                                        }
                                    });
                                });

                                if (filteredTimeSlots.length > 0) {
                                    noAvailableTimeSlots = false;
                                }

                                // console.log(filteredTimeSlots);

                                if (noAvailableTimeSlots) {
                                    if (activeFilter) {
                                        this.displayedTimeSlots = false;
                                        // this.updateSelectedDayTimeSlots(null);
                                    }
                                    else {
                                        noAvailableTimeSlots = false;
                                        this.displayedTimeSlots = this.selectedDayTimeSlots;
                                        // this.updateSelectedDayTimeSlots(this.copyOfSelectedDayTimeSlots);
                                    }
                                }
                                else {
                                    this.displayedTimeSlots = filteredTimeSlots;
                                    // this.updateSelectedDayTimeSlots(filteredTimeSlots);
                                }
                            }
                        }
                    });

                    // console.log(this.displayedTimeSlots);
                }
            },
            deep: true, // Watch deeply if `selectedDayTimeSlots` is a nested object
            immediate: true // Set initial value immediately from prop if needed
        },
    },
}
</script>


<style>
.time-slots-component-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    /* padding: 0 20px; */
    background: #F7F7F7;
    border-radius: 20px;
    margin-bottom: 10px;
}

.time-slots-component-container .time-slots-settings-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 20px 4px;
    /* border: 1px solid; */
}

.time-slots-component-container .select-time-text-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.time-slots-component-container .select-time-text-container p {
    font-size: 25px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    line-height: 35px;
}

.time-slots-component-container .time-slots-settings-content-container {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 6px 0;
}

.time-slots-component-container .time-slots-settings-btn-container {
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    /* border: 1px solid; */
}

.time-slots-component-container .time-slots-settings-img-container, .time-slots-component-container .time-slots-settings-img-container img {
    width: 100%;
}

.time-slots-component-container .settings-filters-options-container {
    flex: 1;
    display: flex;
    /* justify-content: end; */
    align-items: center;
    padding-left: 30px;
}

.time-slots-component-container .filters-options-container-list {
    width: calc(100% - 50px);
    display: flex;
    /* justify-content: center; */
    align-items: center;
    /* border: 1px solid; */
}

.time-slots-component-container .filter-container {
    /* width: 65px; */
    /* height: 36px; */
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #d6d9d9;
    border-radius: 30px;
    margin-right: 15px;
    cursor: pointer;
    background: #ffffff
}

.time-slots-component-container .filter-selected {
    border: none;
    background-color: #009df4;
}

.time-slots-component-container .filter-selected img {
    filter: brightness(0) saturate(100%) invert(100%) sepia(22%) saturate(0%) hue-rotate(201deg) brightness(113%) contrast(100%);
}

.time-slots-component-container .time-filter-img-container {
    width: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2px 10px 4px;
}

.time-slots-component-container .time-filter-img-container img {
    width: 100%;
}

.time-slots-component-container .trainer_gender-filter-img-container, .time-slots-component-container .subscroption_type-filter-img-container {
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin: 5px 15px 0px; */
}

.time-slots-component-container .trainer_gender-filter-img-container img , .time-slots-component-container .subscroption_type-filter-img-container img {
    width: 100%;
}

.time-slots-component-container .available-time-slots-container {
    width: 100%;
    display: flex;
    justify-content: center;
    /* align-items: center; */
    padding: 0 10px;
    /* overflow: auto; */
    height: 150px;
    /* border: 1px solid; */
}

.time-slots-component-container .available-time-slots-container,
.time-slots-component-container .day-time-slots-list,
.time-slots-component-container .time-slot-item,
.time-slots-component-container .time-slots-group-container {
    width: 100%;
}

.time-slots-component-container .time-slot-group-list {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    /* border: 1px solid red; */
}

.time-slots-component-container .time-slot {
    /* width: 20%; */
    width: 18%;
    max-width: 65px;
    /* max-width: 65px; */
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px 0;
    margin: 0 calc((100% - (65px * 5)) / 10) 20px;
    padding: 4px 0;
    border: 1px solid #d6d9d9;
    border-radius: 30px;
    cursor: pointer;
}

.time-slots-component-container .time-slot p {
    font-size: 21px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    /* line-height: 25px; */
}

.time-slots-component-container .selected-time-slot {
    background: #009df4;
    border: 1px solid #009df4;
}

.time-slots-component-container .selected-time-slot p {
    color: #ffffff;
}

.time-slots-component-container .no-available-time-slots-text-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
}

.time-slots-component-container .no-available-time-slots-text-container p {
    font-size: 21px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #616365;
    line-height: 25px;
}

@media (max-width: 400px) {
    .time-slots-component-container .time-slots-settings-btn-container {
        width: 35px;
    }

    .time-slots-component-container .time-filter-img-container {
        width: 42px;
    }

    .time-slots-component-container .time-slot {
        width: 18%;
        margin: 0 calc((100% - (18% * 5)) / 10) 20px;
    }

    .time-slots-component-container .time-slot p {
        font-size: calc(14px + 1.4vw);
    }
}

@media (max-width: 320px) {
    .time-slots-component-container .time-slot {
        padding: 1px 0;
    }

    .time-slots-component-container .time-slot p {
        font-size: calc(11px + 1.6vw);
    }
}

</style>